import React from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';
import CircleCheckMarkIcon from '@icons/CircleCheckMarkIcon';
import CircleDangerIcon from '@icons/CircleDangerIcon';
import LoadingSpinnerIcon from '@icons/LoadingSpinnerIcon';
import { ButtonOutlineLarge } from '@styled';

const ButtonOutlineWithStates = ({
    children,
    onClick,
    buttonClasses = '',
    style = {},
    isDisabled = false,
    isSubmitting = false,
    isSuccessful = false,
    isError = false,
}) => {
    const handleOnClick = e => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };

    const classes = classnames(
        'btn',
        'mt-4',
        'mb-1',
        'd-flex',
        'align-items-center',
        'justify-content-center',
        buttonClasses,
        { isSubmitting, isSuccessful, isError },
        { disabled: isDisabled }
    );

    return (
        <ButtonOutlineLarge
            type="submit"
            onClick={handleOnClick}
            className={classes}
            style={{ ...style, zIndex: isSubmitting ? '2' : 'auto' }}
            disabled={isSubmitting || isSuccessful || isError}
        >
            <span className="fade-in-fast d-flex align-items-center justify-content-center">
                {isSubmitting && (
                    <>
                        <LoadingSpinnerIcon fill="#545454" style={{ marginRight: '10px' }} />
                        Saving...
                    </>
                )}
                {isSuccessful && (
                    <>
                        <CircleCheckMarkIcon />
                        Success!
                    </>
                )}
                {isError && (
                    <>
                        <CircleDangerIcon />
                        Error saving.
                    </>
                )}
                {!isSubmitting && !isSuccessful && !isError && children}
            </span>
        </ButtonOutlineLarge>
    );
};

ButtonOutlineWithStates.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    onClick: PropTypes.func,
    buttonClasses: PropTypes.string,
    isDisabled: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    isSuccessful: PropTypes.bool,
    isError: PropTypes.bool,
    style: PropTypes.object,
};

export default ButtonOutlineWithStates;
